import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ChangeTenant2faIcon extends BaseIcon {
    getChildren = () => {
        const color = this.getColor() === 'currentColor' ? '#2e3f58' : this.getColor()

        return [
            <g transform="translate(6832 11055)">
                <rect width="16" height="16" rx="5" transform="translate(-6832 -11055)" fill={color} />
                <path d="M1.337-4.669H.669Q.825-6,2-6H3.338a1.279,1.279,0,0,1,.939.394,1.283,1.283,0,0,1,.392.938v.337q0,.691-1.291,1.791l-.087.078Q2-1.359,2-.728v.059H4.669V0h-4V-.669q0-.691,1.287-1.794l.091-.078q1.291-1.1,1.291-1.791v-.337a.63.63,0,0,0-.2-.467.649.649,0,0,0-.469-.2H2Q1.384-5.331,1.337-4.669ZM5.28,0V-6H8.611v.669h-2v2H7.949v.662H6.611V0ZM9.229,0V-4.669a1.281,1.281,0,0,1,.392-.939A1.281,1.281,0,0,1,10.56-6H11.9a1.279,1.279,0,0,1,.939.394,1.283,1.283,0,0,1,.392.938V0H11.9V-2.669H10.56V0ZM10.56-3.331H11.9V-4.669a.633.633,0,0,0-.2-.467.648.648,0,0,0-.47-.2.646.646,0,0,0-.472.2.635.635,0,0,0-.2.467Z" transform="translate(-6831 -11044)" fill="#fff"/>
            </g>
        ]
    }

    getViewBox = () => '0 0 16 16'
}
